module.exports = __webpack_public_path__ + "static/media/guarantee.3a233a8c.svg";